<template>
    <ul>
        <router-link tag="li" :to="{name: 'profile'}"><a>Cuenta</a></router-link>
        <router-link tag="li" :to="{name: 'account.status'}"><a>Estado de Cuenta</a></router-link>
        <router-link tag="li" :to="{name: 'intentions'}" v-if="customer.web_cliente > 0 && user.level > 0"><a>Intenciones de Pedidos</a></router-link>
        <router-link tag="li" :to="{name: 'order.notes'}"><a>Notas de Pedidos</a></router-link>
        <router-link tag="li" :to="{name: 'sales.notes'}"><a>Notas de Venta</a></router-link>

    </ul>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        computed: {
            ...mapGetters({
                authenticated: 'auth/authenticated',
                user: 'auth/user',
                errors: 'auth/errors',
                customer: 'customer/customer',
            }),
        },

        methods: {
            ...mapActions({
                signOutAction: 'auth/signOut'
            }),

            signOut() {
                this.signOutAction().then(() => {
                    this.$router.replace({
                        name: 'home'
                    })
                })
            }
        }
    }
</script>
